import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table, Divider, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import styles from './EmailList.module.scss';

const EmailList = ({ lists }) => {
    const [isOpen, setIsOpen] = useState(false);
    const users = lists?.otciqUsers;
    const additionalRecipients = lists?.additionalRecipients;
    const hasUsers = !!(users && users.length > 0);
    const hasAddtRecpt = !!(additionalRecipients && additionalRecipients.length > 0);
    const [mobileView, setMobileView] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            // Check browser width and toggle columns accordingly
            if (window.innerWidth < 768) {
                setMobileView(true);
            } else {
                setMobileView(false);
            }
        };

        // Initial setup
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup  
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const columnsUsers = [
        {
            renderCell: item => <div key={item.email}>{item.name} {`(${item.email})`}</div>
        }
    ];

    const columnsAddtRecpt = [
        {
            renderCell: item => <div>{item.email}</div>
        }
    ];

    return (
        <div className={styles.container}>
            <div className={mobileView ? styles.tablesMobile : styles.tables}>
                <div className={styles.users}>
                    <Typography variant='h4'>
                        Company Contacts
                    </Typography>
                    <Divider size='large' color='green' />
                    {hasUsers ? (
                        <Table columns={columnsUsers} data={users} hideHeader errorText={undefined} emptyValue='None Assigned' />
                    ) : (
                        <div className={styles.noneAssigned}>None Assigned</div>
                    )}
                </div>

                <div className={styles.addtRecpt}>
                    <Typography variant='h4'>
                        Additional Recipients
                    </Typography>
                    <Divider size='large' color='green' />
                    {hasAddtRecpt ? (
                        <Table columns={columnsAddtRecpt} data={additionalRecipients} hideHeader errorText={undefined} emptyValue='None Assigned' />
                    ) : (
                        <div className={styles.noneAssigned}>None Assigned</div>
                    )}
                </div>

            </div>

            <div className={styles.contact}>
                <a href='mailto:issuers@otcmarkets.com'>Contact Issuer Services</a> to make changes to Distribution List.
            </div>
        </div>
    );
};

EmailList.propTypes = {
    lists: PropTypes.object
};

export default EmailList;
